import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminLayoutComponent} from './shared/components/layouts/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from './shared/components/layouts/auth-layout/auth-layout.component';
import {BlankLayoutComponent} from './shared/components/layouts/blank-layout/blank-layout.component';
import {AuthGaurd} from './shared/services/auth.gaurd';
import {HasPermissionGuard} from './shared/services/has-permission.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'sessions',
                loadChildren: './views/sessions/sessions.module#SessionsModule'
            }
        ]
    },
    {
        path: '',
        component: BlankLayoutComponent,
        children: [
            {
                path: 'others',
                loadChildren: './views/others/others.module#OthersModule'
            }
        ]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGaurd],
        children: [
            {
                path: 'dashboard',
                loadChildren: './views/dashboard/dashboard.module#DashboardModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'product-configuration',
                loadChildren: './views/product-configuration/product-configuration.module#ProductConfigurationModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: '',
                loadChildren: './views/hrms/hrms.module#HRMSModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'vending-machine',
                loadChildren: './views/vending-machine/vending-machine.module#VendingMachineModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'customer',
                loadChildren: './views/customer/customer.module#CustomerModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'authority-management',
                loadChildren: './views/authority-management/authority-management.module#AuthorityManagementModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'account-management',
                loadChildren: './views/account-management/account-management.module#AccountManagementModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'agency',
                loadChildren: './views/agency/agency.module#AgencyModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'sales',
                loadChildren: './views/sales/sales.module#SalesModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'report',
                loadChildren: './views/report/report.module#ReportModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'document',
                loadChildren: './views/others/others.module#OthersModule'
            },
            {
                path: 'uikits',
                loadChildren: './views/ui-kits/ui-kits.module#UiKitsModule'
            },
            {
                path: 'forms',
                loadChildren: './views/forms/forms.module#AppFormsModule'
            },
            {
                path: 'invoice',
                loadChildren: './views/invoice/invoice.module#InvoiceModule'
            },
            {
                path: 'inbox',
                loadChildren: './views/inbox/inbox.module#InboxModule'
            },
            {
                path: 'calendar',
                loadChildren: './views/calendar/calendar.module#CalendarAppModule'
            },
            {
                path: 'chat',
                loadChildren: './views/chat/chat.module#ChatModule'
            },
            {
                path: 'tables',
                loadChildren: './views/data-tables/data-tables.module#DataTablesModule'
            },
            {
                path: 'pages',
                loadChildren: './views/pages/pages.module#PagesModule'
            },
            {
                path: 'personal-profile',
                loadChildren: './views/personal-profile/personal-profile.module#PersonalProfileModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            },
            {
                path: 'cms',
                loadChildren: './views/cms/cms.module#CmsModule',
                data: {id: 1},
                canActivate: [HasPermissionGuard]
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'others/404'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
